<template>
  <div>
    <div class="summary-container">      
      <div class="summary-card" v-for="(item, key) in cards" :key="`card-${key}`">
        <p class="summary-title">
          {{ item.title }}
        </p>
        <p class="summary-value">
            <spinner v-if="loading" :colorScheme="'dark'" />
            <span v-else>{{ item.value.toLocaleString() }}</span>
          </p>
      </div>
    </div>
    <div class="summary-card card-total">
      <p class="summary-value">
          <spinner v-if="loading" :colorScheme="'dark'" />
          <span v-else>{{ $t('WHATSAPP_CONSUMPTIONS_REPORT.TOTAL') }} : {{ total.toLocaleString() }}</span>
        </p>
    </div>
  </div>
</template>

<script>

import Spinner from 'shared/components/Spinner.vue';

export default {
  name: 'WhatsappEventsSummary',
  components: {    
    Spinner
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },

  },
  computed: {
    total() {
      return this.cards.reduce((sum, item) => sum + item.value, 0);
    },
    cards(){
      return [
        {
          title: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.TEMPLATES_MARKETING'),
          value: this.data.reduce((sum, item) => sum + item.marketing_total, 0)
        },
        {
          title: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.TEMPLATES_UTILITY'),
          value: this.data.reduce((sum, item) => sum + item.utility_total, 0)
        },
        {
          title: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.TEMPLATES_AUTHENTICATION'),
          value: this.data.reduce((sum, item) => sum + item.authentication_total, 0)
        },
        {
          title: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.CONVERSATONS_SERVICE'),
          value: this.data.reduce((sum, item) => sum + item.service_total, 0)
        },
        {
          title: this.$t('WHATSAPP_CONSUMPTIONS_REPORT.CATEGORY.MESSAGES_SERVICE'),
          value: this.data.reduce((sum, item) => sum + item.messages_service_total, 0)
        }
      ]
    }
  },
};
</script>

<style lang="scss" scoped>
.summary-container {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}

.summary-card {
  background-color: #e0e0e0;
  border-radius: 10px;
  padding: 20px 24px;
  max-width: 18%;
  flex: 0 0 auto;
  text-align: center;
  &.card-total {
    width: 100%;
    max-width: inherit;
    padding: 10px 24px;
    text-align: left;
  }
  .summary-title {
    font-size: 14px;
    color: #555;
    margin-bottom: 8px;
  }

  .summary-value {
    font-size: 24px;
    font-weight: bold;
    color: #222;
  }
}


</style>
